<template>
  <v-container>
    <v-row dense>
      <v-col cols="12" sm="6" md="3" v-for="item in anomalies" :key="item.action">
        <!-- Card della stessa altezza nella riga, pulsante sempre in fondo -->
        <v-card class="d-flex flex-column" height="100%">
          <v-card-title class="anomaly-title">{{ item.name }}</v-card-title>
          <v-card-text class="flex-grow-1">
            <div class="text-h4" :class="item.count > 0 ? 'red--text' : 'green--text'">
              {{ item.count !== null ? item.count : '...' }}
            </div>
            <div class="mt-2">{{ item.description }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn :to="{ name: item.action }">Dettaglio</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { anomalyService } from '../../utils/services/anomaly.service';
import { routeNames } from '../../config/router/routeNames';

export default {
  name: 'AnomalyDashboard',
  data() {
    return {
      anomalies: [
        {
          name: 'Prenotati con booked_up = 0',
          action: routeNames.ANOMALY_BOOKED_ZERO,
          description: 'Libri con stato PRENOTATO ma quantita\' prenotata a zero',
          count: null,
        },
        {
          name: 'Assegnati in loop',
          action: routeNames.ANOMALY_ASSIGNED_LOOP,
          description: 'Libri ASSEGNATI con prenotazione che non cambiano stato',
          count: null,
        },
        {
          name: 'Assegnazioni duplicate',
          action: routeNames.ANOMALY_DUPLICATE,
          description: 'Stesso libro assegnato piu\' volte allo stesso docente',
          count: null,
        },
        {
          name: 'Prenotati ma disponibili',
          action: routeNames.ANOMALY_BOOKED_AVAILABLE,
          description: 'Libri prenotati con giacenza disponibile in magazzino',
          count: null,
        },
        {
          name: 'Scuola non collegata al propagandista',
          action: routeNames.ANOMALY_SCHOOL_MISMATCH,
          description: 'Libri la cui scuola non e assegnata al propagandista della campagna',
          count: null,
        },
        {
          name: 'Libri ordinati non ricevuti',
          action: routeNames.ANOMALY_ORDERS_MISSING,
          description: 'Copie ordinate ma non ancora ricevute dal fornitore',
          count: null,
        },
        {
          name: 'Docenti senza scuola valida',
          action: routeNames.ANOMALY_ORPHAN_TEACHERS,
          description: 'Docenti senza sede, o associati a sedi e scuole cancellate',
          count: null,
        },
        {
          name: 'Anomalie magazzino',
          action: routeNames.ANOMALY_VQTY_MISMATCH,
          description: 'Disponibilita\' superiore alla giacenza o valori negativi',
          count: null,
        },
      ],
    };
  },
  created() {
    this.fetchSummary();
  },
  methods: {
    async fetchSummary() {
      try {
        const response = await anomalyService.getSummary();
        const data = response.data;
        this.anomalies[0].count = data.booked_zero;
        this.anomalies[1].count = data.assigned_loop;
        this.anomalies[2].count = data.duplicate_assignments;
        this.anomalies[3].count = data.booked_but_available;
        this.anomalies[4].count = data.school_mismatch;
        this.anomalies[5].count = data.orders_missing;
        this.anomalies[6].count = data.orphan_teachers;
        this.anomalies[7].count = data.vqty_mismatch;
      } catch (error) {
        console.error('Error fetching anomaly summary', error);
      }
    },
  },
};
</script>

<style scoped>
  /* v-card-title spezza le parole a metà (word-break: break-all) */
  .anomaly-title {
    word-break: normal;
  }
</style>
